import useIsGroupAdmin from '@hooks/useIsGroupAdmin';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useInterviewOptions } from '@providers/InterviewsProvider';
import {
    AccessRole,
    CURRENT_ACCESS,
    UserWithClaims,
    getGroupClaimsKey,
} from '@synergetx/puppet-interview-types';
import { memo, useEffect, useState } from 'react';

interface Props {
    users: UserWithClaims[] | null;
    setUsersToShow: React.Dispatch<React.SetStateAction<UserWithClaims[] | null>>;
}

const UserFilterButtonGroup = ({ users, setUsersToShow }: Props) => {
    const { selectedInterview } = useInterviewOptions();
    const groupId = selectedInterview?.groupId;
    // const interviewId = selectedInterview?.id;
    const isGroupAdmin = useIsGroupAdmin();
    const [activeButton, setActiveButton] = useState<'all' | AccessRole>('all');

    useEffect(() => {
        if (!users || !groupId) return;
        if (activeButton === 'all') {
            setUsersToShow(
                users.filter((user) =>
                    CURRENT_ACCESS.includes(
                        user.claims[getGroupClaimsKey(groupId)] || AccessRole.NONE,
                    ),
                ),
            );
        } else {
            setUsersToShow(
                users.filter((user) => user.claims[getGroupClaimsKey(groupId)] === activeButton),
            );
        }
    }, [activeButton, groupId, setUsersToShow, users]);

    return (
        <Box
            sx={{
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <ToggleButtonGroup value={activeButton} sx={{ marginLeft: '1rem' }}>
                <ToggleButton value={'all'} onClick={() => setActiveButton('all')}>
                    All Active
                </ToggleButton>

                {isGroupAdmin ? (
                    <ToggleButton
                        value={AccessRole.ADMIN}
                        onClick={() => setActiveButton(AccessRole.ADMIN)}
                    >
                        Admin
                    </ToggleButton>
                ) : null}

                <ToggleButton
                    value={AccessRole.SUPERVISOR}
                    onClick={() => setActiveButton(AccessRole.SUPERVISOR)}
                >
                    Project Lead
                </ToggleButton>

                <ToggleButton
                    value={AccessRole.ASSESSOR}
                    onClick={() => setActiveButton(AccessRole.ASSESSOR)}
                >
                    Assessor
                </ToggleButton>

                <ToggleButton
                    value={AccessRole.NONE}
                    onClick={() => setActiveButton(AccessRole.NONE)}
                >
                    Removed
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default memo(UserFilterButtonGroup);
